import type { Dispatch } from "redux";
import actions from "~/shared/actions";
import type { Fondsskole } from "~/shared/reducers/fondsskole";

export function stepCompleted(data: Fondsskole) {
	return (dispatch: Dispatch) => {
		dispatch(actions.stepCompleted(data));
	};
}
